import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import Contact from '../home/components/Contact';
import CityHero from '../../components/feature/CityHero';

export default function ReparationFenetreMeyzieu() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <CityHero cityName="Meyzieu" />

      {/* Service Types Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* PVC Section */}
          <div className="mb-20">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div className="relative h-96 rounded-2xl overflow-hidden shadow-xl">
                <img
                  src="https://public.readdy.ai/ai/img_res/ac82960c6fc7d4c9c285bef3831d964d.jpg"
                  alt="Réparation fenêtre PVC à Meyzieu"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">
                  Réparation Fenêtres PVC à Meyzieu
                </h2>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  Nos experts interviennent rapidement pour tous vos problèmes de fenêtres PVC. Du simple ajustement au remplacement de vitrage, nous garantissons des réparations durables et professionnelles.
                </p>
                <ul className="space-y-3 mb-8">
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 text-xl mr-3 mt-1"></i>
                    <span className="text-gray-700">Remplacement de vitrage cassé ou fissuré</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 text-xl mr-3 mt-1"></i>
                    <span className="text-gray-700">Réparation des mécanismes d'ouverture</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 text-xl mr-3 mt-1"></i>
                    <span className="text-gray-700">Changement de joints d'étanchéité</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 text-xl mr-3 mt-1"></i>
                    <span className="text-gray-700">Ajustement et réglage des ouvrants</span>
                  </li>
                </ul>
                <a
                  href="/reparation-fenetre-pvc-lyon"
                  className="inline-flex items-center px-6 py-3 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  En savoir plus sur la réparation PVC
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Bois Section */}
          <div className="mb-20">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div className="order-2 md:order-1">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">
                  Réparation Fenêtres Bois à Meyzieu
                </h2>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  Spécialistes de la restauration de fenêtres en bois, nous redonnons vie à vos menuiseries anciennes tout en préservant leur charme authentique et leur cachet d'origine.
                </p>
                <ul className="space-y-3 mb-8">
                  <li className="flex items-start">
                    <i className="ri-check-line text-amber-600 text-xl mr-3 mt-1"></i>
                    <span className="text-gray-700">Traitement du bois contre l'humidité et les insectes</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-amber-600 text-xl mr-3 mt-1"></i>
                    <span className="text-gray-700">Réparation des parties endommagées</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-amber-600 text-xl mr-3 mt-1"></i>
                    <span className="text-gray-700">Restauration complète de fenêtres anciennes</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-amber-600 text-xl mr-3 mt-1"></i>
                    <span className="text-gray-700">Finitions et peintures professionnelles</span>
                  </li>
                </ul>
                <a
                  href="/reparation-fenetre-bois-lyon"
                  className="inline-flex items-center px-6 py-3 bg-amber-600 text-white font-semibold rounded-lg hover:bg-amber-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  En savoir plus sur la réparation Bois
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
              <div className="relative h-96 rounded-2xl overflow-hidden shadow-xl order-1 md:order-2">
                <img
                  src="https://readdy.ai/api/search-image?query=elegant%20wooden%20window%20frame%20with%20traditional%20craftsmanship%2C%20natural%20wood%20grain%20texture%2C%20classic%20carpentry%20details%2C%20warm%20interior%20lighting%2C%20artisan%20quality%20restoration%2C%20heritage%20home%20renovation&width=600&height=400&seq=wood-window-repair-service-08&orientation=landscape"
                  alt="Réparation fenêtre bois à Meyzieu"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          {/* Aluminium Section */}
          <div>
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div className="relative h-96 rounded-2xl overflow-hidden shadow-xl">
                <img
                  src="https://readdy.ai/api/search-image?query=sleek%20aluminum%20window%20frame%20with%20slim%20profile%2C%20modern%20architectural%20design%2C%20metallic%20finish%2C%20contemporary%20building%20facade%2C%20large%20glass%20panels%2C%20industrial%20elegance%2C%20professional%20installation&width=600&height=400&seq=alu-window-repair-service-08&orientation=landscape"
                  alt="Réparation fenêtre aluminium à Meyzieu"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">
                  Réparation Fenêtres Aluminium à Meyzieu
                </h2>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  Experts en menuiserie aluminium, nous intervenons sur tous types de fenêtres et baies vitrées alu pour garantir leur bon fonctionnement et leur longévité.
                </p>
                <ul className="space-y-3 mb-8">
                  <li className="flex items-start">
                    <i className="ri-check-line text-gray-600 text-xl mr-3 mt-1"></i>
                    <span className="text-gray-700">Réparation de baies vitrées coulissantes</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-gray-600 text-xl mr-3 mt-1"></i>
                    <span className="text-gray-700">Remplacement de galets et rails</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-gray-600 text-xl mr-3 mt-1"></i>
                    <span className="text-gray-700">Traitement anti-oxydation</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-gray-600 text-xl mr-3 mt-1"></i>
                    <span className="text-gray-700">Rénovation de châssis aluminium</span>
                  </li>
                </ul>
                <a
                  href="/reparation-fenetre-alu-lyon"
                  className="inline-flex items-center px-6 py-3 bg-gray-700 text-white font-semibold rounded-lg hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
                >
                  En savoir plus sur la réparation Aluminium
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h2 className="text-3xl lg:text-4xl font-extrabold text-gray-900 text-center mb-12">
            Pourquoi Nous Choisir à Meyzieu ?
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { icon: 'ri-time-line', title: 'Intervention Rapide', desc: 'Sous 24h à Meyzieu' },
              { icon: 'ri-shield-star-line', title: 'Garantie Qualité', desc: 'Travaux garantis 2 ans' },
              { icon: 'ri-money-euro-circle-line', title: 'Devis Gratuit', desc: 'Sans engagement' },
              { icon: 'ri-customer-service-2-line', title: 'Disponible 7j/7', desc: 'À votre écoute' }
            ].map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${item.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-600 text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <Contact />
      
      <Footer />
    </div>
  );
}
